import { render, staticRenderFns } from "./ComponentBenefitsPaid.vue?vue&type=template&id=fab6a7a2&"
import script from "./ComponentBenefitsPaid.vue?vue&type=script&lang=ts&"
export * from "./ComponentBenefitsPaid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports